export const SensorsEndpoints = {
    basePath: '',
    endpoints: {
        allPoi: {
            path: '/stations',
            method: 'GET',
            auth: true,
            get: null,
            fallback: [],
            swrOptions: {
                revalidateOnFocus: false
            }
        },
        all: {
            path: '/stations?{{cluster}}camera={{camera}}&gateway={{gateway}}&people_counter={{people_counter}}&wifi={{wifi}}{{envPath}}',
            method: 'GET',
            auth: true,
            get: null,
            fallback: [],
            swrOptions: {
                revalidateOnFocus: false
            }
        },
        allGeneric: {
            path: '/stations{{path}}',
            method: 'GET',
            auth: true,
            get: null,
            fallback: [],
            swrOptions: {
                revalidateOnFocus: false
            }
        },
        getStation: {
            path: '/stations/{{station_id}}',
            method: 'GET',
            auth: true,
            get: null,
            fallback: [],
            swrOptions: {
                revalidateOnFocus: false
            }
        },
        getStatus: {
            path: '/stations/status?{{cluster}}camera={{camera}}&gateway={{gateway}}&people_counter={{people_counter}}&wifi={{wifi}}{{envPath}}',
            method: 'GET',
            auth: true,
            get: null,
            fallback: [],
            // swrOptions: {
            //     revalidateOnFocus: false
            // }
        },
        getStatusHome: {
            path: '/stations/status?{{cluster}}camera={{camera}}&gateway={{gateway}}&wifi={{wifi}}&people_counter={{people_counter}}{{envPath}}',
            method: 'GET',
            auth: true,
            get: null,
            fallback: [],
            // swrOptions: {
            //     revalidateOnFocus: false
            // }
        },
        setMuteAlert: {
            path: '/stations/status/alerts/{{alert_id}}/mute',
            method: 'PUT',
            auth: true,
            get: null,
            fallback: [],
            swrOptions: {
                revalidateOnFocus: false
            }
        },
        allPeopleCounter: {
            path: '/stations?people_counter=true',
            method: 'GET',
            auth: true,
            get: null,
            fallback: [],
            swrOptions: {
                revalidateOnFocus: false
            }
        },
        getStationDetail: {
            path: '/stations/{{id}}',
            method: 'GET',
            auth: true,
            get: null,
            fallback: null,
        },
        getSensorStation: {
            path: '/stations/sensors/{{id}}',
            method: 'GET',
            auth: true,
            get: null,
            fallback: null,
        },
        setSensorStationStatus: {
            path: '/stations/sensors/{{sensor_id}}/state',
            method: 'PUT',
            auth: true,
            get: null,
            fallback: null,
        },
        addStationDetail: {
            path: '/stations',
            method: 'POST',
            auth: true,
            get: null,
            fallback: null,
            swr: {
                revalidateOnFocus: false
            }
        },
        updateStationDetail: {
            path: '/stations/{{id}}',
            method: 'PUT',
            auth: true,
            get: null,
            fallback: null,
        },
        deleteStationDetail: {
            path: '/stations/{{station_id}}',
            method: 'DELETE',
            auth: true,
            get: null,
            fallback: null,
        },
        deleteStationPeopleCounter: {
            path: '/stations/{{station_id}}/pcounter/{{pcounter_id}}',
            method: 'DELETE',
            auth: true,
            get: null,
            fallback: null,
        },
        updatePeopleCounterId: {
            path: '/stations/{{id}}/pcounter',
            method: 'PUT',
            auth: true,
            get: null,
            fallback: null,
        },
        getPCStation: {
            path: '/stations/{{id}}/pcounter/{{pcounter_id}}',
            method: 'GET',
            auth: true,
            get: null,
            fallback: null,
        },
        //sensors
        addSensor: {
            path: '/stations/{{id}}/sensors',
            method: 'POST',
            auth: true,
            get: null,
            fallback: null,
            swr: {
                revalidateOnFocus: false
            }
        },
        deleteSensorOfStation: {
            path: '/stations/{{station_id}}/sensors/{{sensor_id}}',
            method: 'DELETE',
            auth: true,
            get: null,
            fallback: null,
        },
        deleteSensorPCount: {
            path: '/stations/{{station_id}}/pcounter/{{pcounter_id}}',
            method: 'DELETE',
            auth: true,
            get: null,
            fallback: null,
        },
        //DATI GRAFICI
        getChartData: {
            path: '/stations/data',
            method: 'GET',
            auth: true,
            get: null,
            fallback: null,
        },
        getDataGeneric: {
            path: '/stations/data{{path}}',
            method: 'GET',
            auth: true,
            get: null,
            fallback: null,
        },
        getDataDateTime: {
            path: '/stations/data',
            method: 'GET',
            auth: true,
            get: null,
            fallback: null,
        },
        getDataCurrentGeneric: {
            path: '/stations/data/current{{path}}',
            method: 'GET',
            auth: true,
            get: null,
            fallback: null,
        },
        getDataStationIdGeneric: {
            path: '/stations/{{station_id}}/data{{path}}',
            method: 'GET',
            auth: true,
            get: null,
            fallback: null,
        },
        getDataCurrentStationId: {
            path: '/stations/{{station_id}}/data/current',
            method: 'GET',
            auth: true,
            get: null,
            fallback: null,
        },
        //DATI METRICHE
        getByStationCurrentData: {
            path: '/stations/data/metric/{{metric}}/bystation/current{{path}}',
            method: 'GET',
            auth: true,
            get: null,
            fallback: null,
        },
        getMetricByStationGeneric: {
            path: '/stations/data/metric/{{metric}}/bystation{{path}}',
            method: 'GET',
            auth: true,
            get: null,
            fallback: null,
        },
        getMetricStationIdGeneric: {
            path: '/stations/{{station_id}}/data/metric/{{metric}}{{path}}',
            method: 'GET',
            auth: true,
            get: null,
            fallback: null,
        },
        getMetricGeneric: {
            path: '/stations/data/metric/{{metric}}{{path}}',
            method: 'GET',
            auth: true,
            get: null,
            fallback: null,
        },
        addGatwayId: {
            path: '/stations/{{station_id}}/gw',
            method: 'POST',
            auth: true,
            get: null,
            fallback: null,
            swr: {
                revalidateOnFocus: false
            }
        },
        updateGatwayId: {
            path: '/stations/{{station_id}}/gw',
            method: 'PUT',
            auth: true,
            get: null,
            fallback: null,
        },
        deleteGatwayId: {
            path: '/stations/{{station_id}}/gw/{{gatway_id}}',
            method: 'DELETE',
            auth: true,
            get: null,
            fallback: null,
        },
        downloadGeneric: {
            path: '/stations/data/metric/{{metric}}/download?time_zone={{timeZone}}{{path}}',
            method: 'GET',
            auth: true,
            get: null,
            fallback: null,
        },
        getAlertsGeneric: {
            path: '/stations/status/alerts?muted={{muted}}&inactive={{inactive}}{{cluster}}',
            method: 'GET',
            auth: true,
            get: null,
            fallback: null,
        },
        downloadHistoricalData: {
            path: '/stations/data/historical/zip?date={{date}}',
            method: 'GET',
            auth: true,
            get: null,
            fallback: null,
        },
        getStats: {
            path: '/stations/data/current/stats{{path}}',
            method: 'GET',
            auth: true,
            get: null,
            fallback: [],
        },
        getStatsStation: {
            path: '/stations/{{station_id}}/data/current/stats',
            method: 'GET',
            auth: true,
            get: null,
            fallback: [],
        },
        getStatsMetrics: {
            path: '/stations/data/metric/{{metric}}/current/stats{{path}}',
            method: 'GET',
            auth: true,
            get: null,
            fallback: [],
        },
        getStatsStationMetrics: {
            path: '/stations/{{station_id}}/data/metric/{{metric}}/current/stats',
            method: 'GET',
            auth: true,
            get: null,
            fallback: [],
        },
    }
}

export default SensorsEndpoints;
